import * as React from "react";
import type { SVGProps } from "react";
const SvgSmile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.8 13.4a1 1 0 1 0-1.6 1.2zm8 1.2a1 1 0 0 0-1.6-1.2zM9 8a1 1 0 0 0 0 2zm.01 2a1 1 0 0 0 0-2zM15 8a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zM8 14l-.8.6.001.001.001.002.003.004.007.009.021.027.07.086q.089.107.248.275c.213.222.522.513.923.805.798.58 2 1.191 3.526 1.191v-2c-.975 0-1.772-.39-2.35-.809a5 5 0 0 1-.815-.748l-.034-.041-.004-.006.002.003S8.8 13.4 8 14m4 3c1.525 0 2.728-.61 3.526-1.191a7 7 0 0 0 1.17-1.08q.045-.053.07-.086.014-.016.022-.027l.007-.01.003-.003.001-.002S16.8 14.6 16 14a122 122 0 0 1-.8-.601l.002-.001v-.002h.001l-.005.006-.033.041q-.05.061-.16.178a5 5 0 0 1-.656.57c-.577.42-1.374.809-2.349.809zm-3-7h.01V8H9zm6 0h.01V8H15z"
    />
  </svg>
);
export default SvgSmile;
